// Timer Tool — online countdown timer, stopwatch, and preset timers.
import { m } from "@/paraglide/messages";
import type { Tool } from "../index";
import { TIMER_PRESETS } from "./lib/presets";

export const timerTool: Tool = {
  id: "timer",
  name: () => m.timer_tool_name(),
  description: () => m.timer_tool_description(),
  icon: "⏱️",
  basePath: "/timer",
  status: "stable",
  tags: ["timer", "stopwatch", "countdown", "pomodoro"],
  pages: [
    {
      name: () => m.timer_nav_timer(),
      path: "/timer",
      description: () => m.timer_nav_timer_desc(),
      icon: "⏱️",
    },
    {
      name: () => m.timer_nav_stopwatch(),
      path: "/timer/stopwatch",
      description: () => m.timer_nav_stopwatch_desc(),
      icon: "⏲️",
    },
    {
      name: () => m.timer_pomodoro_nav(),
      path: "/timer/pomodoro-timer",
      description: () => m.timer_nav_preset_desc(),
      icon: "🍅",
    },
    {
      name: () => TIMER_PRESETS["5-minute-timer"].navName(),
      path: "/timer/5-minute-timer",
      description: () => m.timer_nav_preset_desc(),
      icon: "⏳",
    },
    {
      name: () => TIMER_PRESETS["10-minute-timer"].navName(),
      path: "/timer/10-minute-timer",
      description: () => m.timer_nav_preset_desc(),
      icon: "⏳",
    },
  ],
};
